export default __webpack_public_path__ + "static/2-ed9aea0432987d391cf922eefaf6969a.svg";